export default "__VITE_ASSET__BnqyjYSs__"